.results {
    composes: container from "../../styles/composable/layout.module.css";
    composes: listReset from "../../styles/composable/utility.module.css";
}
